<template>
  <div class="newsletter-admin" v-if="currentUser">
    <div class="page-header">
      <h1>Wyślij newsletter</h1>
      <button class="btn-outline" @click="resetNewsletterForm">Wyczyść formularz</button>
    </div>

    <div class="section-card">
      <div class="section-card-header">
        <h2>Konfiguracja wiadomości</h2>
        <p class="section-subtitle">Uzupełnij dane newslettera, a następnie przejdź do podglądu.</p>
      </div>

      <form @submit.prevent="sendToConfirm" class="newsletter-form">
        <div class="form-grid" v-if="!showPreview">
          <div class="form-group">
            <label for="subject">Temat</label>
            <input type="text" id="subject" v-model="newsletter.subject" required>
          </div>

          <div class="form-group">
            <label for="title">Tytuł</label>
            <input type="text" id="title" v-model="newsletter.title" required>
          </div>

          <div class="form-group">
            <label for="recipient">Grupy odbiorców</label>
            <select v-model="newsletter.role_id" id="recipient">
              <option value="0">Brak</option>
              <option value="2">Specjaliści</option>
              <option value="3">Właściciele zwierząt</option>
              <option value="5">Placówki</option>
            </select>
          </div>
        </div>

        <div v-if="!showPreview" class="editor-section" :style="{ marginTop: newsletter.role_id != 5 ? '20px' : '0' }">
          <div class="checkboxes-box" v-if="newsletter.role_id == 5">
            <label class="checkbox-row" for="addDeleteLink">
              <input type="checkbox" id="addDeleteLink" name="addDeleteLink" v-model="addDeleteLink">
              <span>Dodaj link usuwający konto</span>
            </label>
            <label class="checkbox-row" for="addActiveLink">
              <input type="checkbox" id="addActiveLink" name="addActiveLink" v-model="addActiveLink">
              <span>Dodaj link aktywujący konto</span>
            </label>
          </div>
          <CKEditor v-model="newsletter.content" />
        </div>

        <div class="other-emails" v-if="!showPreview">
          <label for="emails">Pozostali odbiorcy (adresy e-mail po przecinku)</label>
          <textarea name="emails" id="emails" cols="30" rows="8" v-model="newsletter.emails"></textarea>
        </div>

        <div class="form-actions">
          <button type="submit" class="btn-primary">{{ showPreview ? 'Anuluj' : 'Podgląd i wyślij' }}</button>
        </div>
      </form>
    </div>

    <div class="section-card preview-card" v-if="showPreview">
      <div class="section-card-header">
        <h2>Podgląd wiadomości</h2>
        <p class="section-subtitle">Sprawdź dane przed finalną wysyłką.</p>
      </div>

      <div class="preview-meta">
        <table class="desktop">
          <tr><td>Temat</td><td>{{ newsletter.subject ? newsletter.subject : 'nie podano' }}</td></tr>
          <tr><td>Do</td><td>{{ newsletter.role_id == '2' ? 'specjalistów' : newsletter.role_id == '3' ? 'właścicieli zwierząt' : newsletter.role_id == '5' ? 'placówek' : 'nie podano' }}</td></tr>
          <tr><td>Pozostali odbiorcy</td><td>{{ newsletter.emails ? newsletter.emails.split(',').length : '0' }}</td></tr>
        </table>

        <table class="mobile">
          <tr><th>Temat:</th></tr>
          <tr><td>{{ newsletter.subject ? newsletter.subject : 'nie podano' }}</td></tr>
          <tr><th>Do:</th></tr>
          <tr><td>{{ newsletter.role_id == '2' ? 'specjalistów' : newsletter.role_id == '3' ? 'właścicieli zwierząt' : newsletter.role_id == '5' ? 'placówek' : 'nie podano' }}</td></tr>
          <tr><th>Pozostali odbiorcy:</th></tr>
          <tr><td>{{ newsletter.emails ? newsletter.emails.split(',').length : '0' }}</td></tr>
        </table>
      </div>

      <div class="newsletter-preview-mail">
        <h3>{{ newsletter.title }}</h3>
        <div v-html="newsletter.content"></div>
      </div>

      <div class="preview-actions">
        <button class="btn-primary" @click="sendNewsletter">Potwierdź wysyłkę</button>
        <img class="loading" src="@/assets/icons/loading.gif" v-if="loading" alt="Ładowanie...">
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import authHeader from '@/services/auth-header';
import CKEditor from '@/components/CKEditor.vue';
import { useAuthStore } from '@/stores/auth';
import { useAppStore } from '@/stores/app';

export default {
  name: 'SendNewsletter',
  components: { CKEditor },
  setup() {
    return {
      authStore: useAuthStore(),
      appStore: useAppStore(),
    };
  },
  data() {
    return {
      newsletter: {
        subject: '',
        title: '',
        content: '',
        role_id: '0',
        emails: '',
      },
      showPreview: false,
      loading: false,
      addDeleteLink: false,
      addActiveLink: false,
    };
  },
  computed: {
    currentUser() {
      return this.authStore.user;
    },
  },
  mounted() {
    if (!this.currentUser) {
      this.$router.push('/login');
    } else if (this.currentUser.role_id !== 1) {
      this.$router.push('/login');
    }
  },
  methods: {
    sendToConfirm() {
      if (this.newsletter.content && (this.newsletter.emails || this.newsletter.role_id !== '0')) {
        this.showPreview = !this.showPreview;
        this.newsletter.emails = this.newsletter.emails.replace(/\s/g, '');
        if (this.newsletter.emails.charAt(this.newsletter.emails.length - 1) == ',') {
          this.newsletter.emails = this.newsletter.emails.slice(0, -1);
        }
      } else {
        this.appStore.setIsAlert('uzupełnij treść i odbiorców (pozostałych lub grupy)');
      }
    },
    sendNewsletter() {
      if (this.newsletter.title && this.newsletter.subject) {
        if (this.newsletter.content && (this.newsletter.emails || this.newsletter.role_id !== '0')) {
          this.loading = true;
          axios.post('/PrepareNewsletter', {
            role_id: this.newsletter.role_id,
            emails: this.newsletter.emails,
          }, authHeader()).then(res => {
            if (res.data.count == 0) {
              this.appStore.setIsAlert('Brak użytkowników w bazie');
              this.resetNewsletterForm();
            } else {
              this.newsletter.content = `${this.newsletter.content}<br><br><a style="font-size: 10px;" href="https://m2vet.pl/confirm-newsletter?newsletterId=[!newsletterId!]&status=true">zrezygnuj z newslettera</a>`;
              if (this.addDeleteLink) {
                this.newsletter.content = `${this.newsletter.content}<br><a style="font-size: 10px;" href="https://m2vet.pl/confirm-newsletter?newsletterId=[!newsletterId!]&status=false">usuń konto</a>`;
              }
              if (this.addActiveLink) {
                this.newsletter.content = `${this.newsletter.content}<br><a style="font-size: 10px;" href="https://m2vet.pl/confirm-newsletter?newsletterId=[!newsletterId!]&active=true">aktywuj konto</a>`;
              }

              axios.post('/SendNewsletter', this.newsletter, authHeader()).then(() => {
                this.appStore.setIsSuccess('Pomyślnie wysłano newsletter');
                this.resetNewsletterForm();
              }).catch(() => {
                this.resetNewsletterForm();
              });
            }
          }).catch(() => {
            this.resetNewsletterForm();
          });
        } else {
          this.appStore.setIsAlert('uzupełnij treść i odbiorców (pozostałych lub grupy)');
        }
      } else {
        this.appStore.setIsAlert('uzupełnij temat i tytuł');
      }
    },
    resetNewsletterForm() {
      this.loading = false;
      this.showPreview = false;
      this.newsletter.subject = '';
      this.newsletter.title = '';
      this.newsletter.content = '';
      this.newsletter.role_id = '0';
      this.newsletter.emails = '';
      this.addDeleteLink = false;
      this.addActiveLink = false;
    },
  },
};
</script>

<style scoped lang="scss">
.newsletter-admin {
  max-width: 1200px;
  margin: 0 auto;
  padding: 32px 16px;
  font-family: sans-serif;
  box-sizing: border-box;
}

.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 2px solid #e5e7eb;
}

.page-header h1 {
  font-size: 2.8rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0;
}

.section-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.08);
  padding: 24px;
  box-sizing: border-box;
  width: 100%;
  margin-bottom: 20px;
}

.section-card-header {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 16px;
}

.section-card h2 {
  font-size: 2rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0;
}

.section-subtitle {
  margin: 0;
  color: #6b7280;
  font-size: 1.4rem;
}

.newsletter-form {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(180px, 1fr));
  gap: 10px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.form-group label {
  font-size: 1.4rem;
  font-weight: 600;
  color: #374151;
}

.form-group input,
.form-group select,
.other-emails textarea {
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid #d1d5db;
  font-size: 1.4rem;
  outline: none;
  transition: border-color 0.2s, box-shadow 0.2s;
  box-sizing: border-box;
  width: 100%;
}

.form-group input:focus,
.form-group select:focus,
.other-emails textarea:focus {
  border-color: #10b981;
  box-shadow: 0 0 0 2px rgba(16, 185, 129, 0.12);
}

.editor-section {
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 12px;
  background: #fff;
}

.checkboxes-box {
  margin-bottom: 14px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e5e7eb;
}

.checkbox-row {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 1.4rem;
  color: #374151;
}

.checkbox-row input {
  accent-color: #10b981;
  width: 16px;
  height: 16px;
}

.other-emails {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.other-emails label {
  font-size: 1.4rem;
  font-weight: 600;
  color: #374151;
}

.other-emails textarea {
  resize: vertical;
  min-height: 130px;
}

.form-actions,
.preview-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  padding-top: 12px;
  border-top: 1px solid #e5e7eb;
}

.preview-card {
  margin-bottom: 0;
}

.preview-meta table {
  width: 100%;
  max-width: 900px;
  border-collapse: separate;
  border-spacing: 0;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  overflow: hidden;
}

.preview-meta table tr td,
.preview-meta table tr th {
  border-bottom: 1px solid #f1f5f9;
  padding: 10px 12px;
  text-align: left;
  font-size: 1.4rem;
  color: #1f2937;
}

.preview-meta table tr:last-child td,
.preview-meta table tr:last-child th {
  border-bottom: none;
}

.preview-meta table.desktop {
  display: table;
}

.preview-meta table.mobile {
  display: none;
}

.newsletter-preview-mail {
  margin-top: 18px;
  border-top: 1px solid #e5e7eb;
  padding-top: 14px;
}

.newsletter-preview-mail h3 {
  margin: 0 0 10px 0;
  color: #1f2937;
  font-size: 1.9rem;
}

.loading {
  width: 34px;
  height: 34px;
  object-fit: contain;
}

.btn-primary {
  background-color: #f97316;
  color: #fff;
  border: none;
  padding: 10px 16px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 1.4rem;
  font-weight: 600;
  transition: background-color 0.2s;
}

.btn-primary:hover {
  background-color: #ea6c0a;
}

.btn-outline {
  background-color: transparent;
  color: #1f2937;
  padding: 10px 16px;
  border-radius: 8px;
  border: 1px solid #d1d5db;
  font-size: 1.4rem;
  cursor: pointer;
  transition: border-color 0.2s, color 0.2s;
}

.btn-outline:hover {
  border-color: #10b981;
  color: #10b981;
}

@media (max-width: 900px) {
  .form-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 576px) {
  .preview-meta table.desktop {
    display: none;
  }

  .preview-meta table.mobile {
    display: table;
  }
}

@media (max-width: 480px) {
  .newsletter-admin {
    padding: 16px 12px;
  }

  .page-header h1 {
    font-size: 2.2rem;
  }

  .section-card {
    padding: 16px 12px;
    border-radius: 8px;
  }

  .section-card h2 {
    font-size: 1.8rem;
  }

  .btn-primary,
  .btn-outline {
    width: 100%;
    text-align: center;
  }

  .form-actions,
  .preview-actions {
    flex-direction: column;
    align-items: stretch;
  }
}
</style>